function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Energie-gebouw-Energieverbruik",
  transform: "translate(-750.000000, -261.000000)",
  stroke: "#425cd4",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Staafgraph-grijs",
  transform: "translate(751.000000, 262.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.6875,11.7333333 C4.6875,11.4387815 4.45431497,11.2 4.16666667,11.2 L2.08333333,11.2 C1.79568503,11.2 1.5625,11.4387815 1.5625,11.7333333 L1.5625,15.4666667 L4.6875,15.4666667 L4.6875,11.7333333 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9375,6.4 C10.9375,6.10544813 10.704315,5.86666667 10.4166667,5.86666667 L8.33333333,5.86666667 C8.04568503,5.86666667 7.8125,6.10544813 7.8125,6.4 L7.8125,15.4666667 L10.9375,15.4666667 L10.9375,6.4 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1875,9.6 C17.1875,9.30544813 16.954315,9.06666667 16.6666667,9.06666667 L14.5833333,9.06666667 C14.295685,9.06666667 14.0625,9.30544813 14.0625,9.6 L14.0625,15.4666667 L17.1875,15.4666667 L17.1875,9.6 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.4375,1.06666667 C23.4375,0.7721148 23.204315,0.533333333 22.9166667,0.533333333 L20.8333333,0.533333333 C20.545685,0.533333333 20.3125,0.7721148 20.3125,1.06666667 L20.3125,15.4666667 L23.4375,15.4666667 L23.4375,1.06666667 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.525,15.4666667 L24.4833333,15.4666667",
  id: "Path"
}))));
function SvgBarUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Staafgraph-grijs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarUnselected);
export default __webpack_public_path__ + "static/media/Bar_unselected.0ea4d4e35a07898d9577df17e852db23.svg";
export { ForwardRef as ReactComponent };